export enum EditorModes {
  NORMAL = "NORMAL",
  LIVE_PLACE_NEW_MODEL = "LIVE_PLACE_NEW_MODEL",
  LIVE_PLACE_EXISING_MODEL = "LIVE_PLACE_EXISING_MODEL",
}
